import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoricoCarrelloFiltersObject } from '../../clienti/storicocarrello/tabs/StoricoCarrelloFiltersForm';
import { FilterObject } from '@bludata/hook-usetableloader';
import { ArticoloResoInterface } from '../../clienti/storicocarrello/tabs/details/reso/components/WizardResoArticoli';
import { GridRowSelectionModel } from '@mui/x-data-grid';

export interface StoricoCarrelloSliceState {
  selectedCard: number;
  wizardResoStep: number;
  articoliReso: ArticoloResoInterface[];
  selectedArticoliReso: GridRowSelectionModel;
  sostituzioneGaranzia: boolean;
}

const initialState: StoricoCarrelloSliceState = {
  selectedCard: 0,
  wizardResoStep: 0,
  articoliReso: [],
  selectedArticoliReso: {
    ids: new Set(),
    type: 'include',
  },
  sostituzioneGaranzia: false,
};

export const StoricoCarrelloSlice = createSlice({
  name: 'storicocarrello',
  initialState,
  reducers: {
    setSelectedCard(
      state: StoricoCarrelloSliceState,
      action: PayloadAction<number>,
    ) {
      state.selectedCard = action.payload;
    },

    setWizardResoStep(
      state: StoricoCarrelloSliceState,
      action: PayloadAction<number>,
    ) {
      state.wizardResoStep = action.payload;
    },

    setArticoliReso(
      state: StoricoCarrelloSliceState,
      action: PayloadAction<ArticoloResoInterface[]>,
    ) {
      state.articoliReso = action.payload;
    },

    setSelectedArticoliReso(
      state: StoricoCarrelloSliceState,
      action: PayloadAction<GridRowSelectionModel>,
    ) {
      state.selectedArticoliReso = action.payload;
    },

    setSostituzioneGaranzia(
      state: StoricoCarrelloSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.sostituzioneGaranzia = action.payload;
    },

    resetReso(state: StoricoCarrelloSliceState) {
      state.wizardResoStep = initialState.wizardResoStep;
      state.articoliReso = initialState.articoliReso;
      state.selectedArticoliReso = initialState.selectedArticoliReso;
      state.sostituzioneGaranzia = initialState.sostituzioneGaranzia;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSelectedCard,
  setWizardResoStep,
  setArticoliReso,
  setSelectedArticoliReso,
  setSostituzioneGaranzia,
  resetReso,
} = StoricoCarrelloSlice.actions;

export const getStoricoVendutoFilters = (
  filters: StoricoCarrelloFiltersObject,
  codicePersonale: string,
) => {
  const filterArray: FilterObject[] = [
    {
      property: 'codiceCliente',
      operator: '=',
      value: codicePersonale,
    },
  ];

  if (filters.date) {
    filterArray.push({
      property: 'data',
      operator: '=',
      value: filters.date,
      date: true,
    });
  } else {
    if (filters.dateFrom) {
      filterArray.push({
        property: 'data',
        operator: '>=',
        value: filters.dateFrom,
        date: true,
      });
    }
    if (filters.dateTo) {
      filterArray.push({
        property: 'data',
        operator: '<=',
        value: filters.dateTo,
        date: true,
      });
    }
  }
  return filterArray;
};

export default StoricoCarrelloSlice.reducer;
